/* eslint-disable */
import {Iterable} from 'immutable';
import React from 'react';

const entries = x => Object.keys(x).reduce((y, z) => y.push([z, x[z]]) && y, []); // TODO update


export default (WrappedComponent) =>
	(wrappedComponentProps) => {
		const KEY = 0;
		const VALUE = 1;

		const propsJS = entries(wrappedComponentProps) // Object.entries
			.reduce((newProps, wrappedComponentProp) => {
				newProps[wrappedComponentProp[KEY]] =
					Iterable.isIterable(wrappedComponentProp[VALUE])
						? wrappedComponentProp[VALUE].toJS()
						: wrappedComponentProp[VALUE];
				return newProps;
			}, {});

		return <WrappedComponent {...propsJS} />
	};



// WEBPACK FOOTER //
// ./src/common/notify/immutable/toJS.js